import { env } from "../../configs/env";
export type QueryParams = Record<string, string | string[] | undefined>;

const cdn = env.url.cdn;
const cdnWordpress = env.url.cdnWordpress;

class Service {
    public getBaseUrl(path: string): string {
        return `https://finddoc.com${path}`
    }

    public getLocalImageUrl(basePath: string): string {
        if (env.mode === 'development') {
            return `/images/${basePath}`;
        } else {
            return `${cdn}/images/web/${basePath}`;
        }
    }

    public getVideoUrl(basePath: string): string {
        return `${cdn}/video/${basePath}`;
    }

    public getImageUrl(basePath: string): string {
        return `${cdn}/images/${basePath}`;
    }

    public getWpImageUrl(basePath: string): string {
        return `${cdnWordpress}/images/${basePath}`;
    }

    public getLocalImageUrlStyle(basePath: string) {
        return {
            backgroundImage: `url(${this.getLocalImageUrl(basePath)})`,
        }
    }

    public getImageUrlStyle(basePath: string) {
        return {
            backgroundImage: `url(${this.getImageUrl(basePath)})`,
        }
    }

    public getWpImageUrlStyle(basePath: string) {
        return {
            backgroundImage: `url(${this.getWpImageUrl(basePath)})`,
        }
    }

    public preserveQuery(url: string) {
        if (typeof window === 'undefined') {
            return url;
        }

        return `${url}${location.search}`;
    }
}

export const UrlService = new Service();
